import React from 'react';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';

import './WithLabel.scss';
import CommonTooltip from '../common-tooltip/CommonTooltip';
import CommonTip from '../common-tip/CommonTip';

export const LABEL_STYLES = {
  ROW: 'row',
  COLUMN: 'column',
  EQUAL: 'equal',
  ALIGNED: 'aligned',
  CUSTOM: 'custom',
};

const WithLabel = ({
  label = '',
  variant = LABEL_STYLES.ROW,
  children,
  maxWidth,
  isBold = false,
  extraClassName,
  isTwoDots = false,
  isRequired = false,
  tip,
}) => {
  const { t } = useTranslation();

  const inlineStyles = { maxWidth };

  return (
    <div
      style={inlineStyles}
      className={clsx('with-label', `with-label--${variant}`, isBold && 'with-label--bold', extraClassName)}>
      <label className={clsx('with-label_label', extraClassName && ` ${extraClassName}_label`)}>
        {label}
        {isRequired ? (
          <CommonTooltip title={t('required')}>
            <span className={`with-label_label--required`}>*</span>
          </CommonTooltip>
        ) : null}
        {tip ? (
          <span className='with-label_label_tip'>
            <CommonTip tip={tip} />
          </span>
        ) : null}
        {isTwoDots ? ':' : ''}
      </label>
      <div className={clsx('with-label_content', extraClassName && ` ${extraClassName}_content`)}>{children}</div>
    </div>
  );
};

export default WithLabel;
